import { VK_APP_ID } from './vk'

export const VK_APP_URL = `https://vk.com/app${VK_APP_ID}`

/** Shape check only. The server verifies the signature and owns account identity. */
export function canStartVkLogin(search: string): boolean {
  const params = new URLSearchParams(search)
  return params.getAll('vk_app_id').length === 1 && params.get('vk_app_id') === VK_APP_ID
    && params.getAll('vk_user_id').length === 1 && /^[1-9]\d*$/.test(params.get('vk_user_id') ?? '')
    && params.getAll('sign').length === 1 && Boolean(params.get('sign')?.trim())
}
